import { render, staticRenderFns } from "./render-social-number-column-value.vue?vue&type=template&id=09f50359"
import script from "./render-social-number-column-value.vue?vue&type=script&lang=js"
export * from "./render-social-number-column-value.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/nortonpigozzo/Development/nisoftwares/VeinsEnergia-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09f50359')) {
      api.createRecord('09f50359', component.options)
    } else {
      api.reload('09f50359', component.options)
    }
    module.hot.accept("./render-social-number-column-value.vue?vue&type=template&id=09f50359", function () {
      api.rerender('09f50359', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/ui/render/render-social-number-column-value.vue"
export default component.exports